import React, {Component, Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import ProgressBar from "../../ProgressBar";
import {loadComponent} from "../../../../utils/components";
import {get, set} from "../../../../utils/dotutils";





import {saveAs} from 'file-saver'
import XLSX from 'xlsx'

function s2ab (s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
}

function datenum (v, date1904) {
    if (date1904) v+=1462
    var epoch = Date.parse(v)
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000)
}

function sheet_from_array_of_arrays (data) {
    var ws = {}
    var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0}}
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R
            if (range.s.c > C) range.s.c = C
            if (range.e.r < R) range.e.r = R
            if (range.e.c < C) range.e.c = C
            var cell = {v: data[R][C]}
            if (cell.v == null) continue
            var cell_ref = XLSX.utils.encode_cell({c:C, r:R})

            if (typeof cell.v === 'number') cell.t = 'n'
            else if (typeof cell.v === 'boolean') cell.t = 'b'
            else if (cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14]
                cell.v = datenum(cell.v)
            } else cell.t = 's'

            ws[cell_ref] = cell
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range)
    return ws
}







export default class Excel extends React.Component {

    state = {
        opened: false,
        generated: false,
        itemsperpage: 20,
        response: {
            page: 0,
            fullcount: 0,
            items: []
        },
    }

    export = () => {
        this.setState({
            opened: true,
            generated: false,
            itemsperpage: 20,
            response: {
                page: 0,
                fullcount: 0,
                items: []
            },
        },() => {
            const cb = () => {
                if (this.state.response.items.length < this.state.response.fullcount || this.state.response.page === 0) {
                    this.request = this.next();
                    this.request.then(cb);
                } else {
                    this.generate();
                }
            }
            cb();
        });
    }

    next = () => {
        let abort = false;
        let request = null;
        const promise = new Promise((resolve, reject) => {
            const reqparams = {...this.props.reqparams};
            if (reqparams.order && this.props.settings.order) {
                reqparams.order = JSON.parse(reqparams.order);
                let order = this.props.settings.order;
                if (!Array.isArray(order)) {
                    order = [order];
                }
                if (Array.isArray(reqparams.order)) {
                    reqparams.order = [...reqparams.order, ...order];
                } else {
                    reqparams.order = [reqparams.order, ...order];
                }
            }
            request = loadComponent("componentlist", {
                ...reqparams,
                resptype: "json",
                withheader: 1,
                page: this.state.response.page + 1,
                itemsperpage: this.state.itemsperpage,
            });
            request.then((response) => {
                if (abort) return;
                response = {
                    ...response,
                    items: [...((this.state.response || {}).items || []), ...response.items],
                    //fullcount: 100
                };
                this.setState({response}, () => {
                    resolve(response);
                });
            });
            request.catch((e) => {
                reject(e);
            })
        });
        promise.cancel = () => {
            abort = true;
            request && request.abort();
        }
        return promise;
    }

    generate = () => {
        let items = this.state.response.items.map((item) => {
            let newItem = {...item};
            this.props.columns.map((column) => {
                const render = (((this.props.props.columns[column] || {}).browserExport || [])[column] || [])[this.props.index];
                if (render) {
                    set(newItem, column, render(get(item, column), item));
                } else {
                    set(newItem, column, get(item, column));
                }
            });
            return newItem;
        })
        this.setState({
            generated: true,
            response: {
                ...this.state.response,
                items
            }
        }, () => {
            this.download();
        });
    }

    createSheetData = (columns, data, labels = {}) => {
        const sheetData = [columns.map((column) => get(labels, column) || "")];
        data = typeof(data) === 'function' ? data() : data

        data.forEach(row => {
            const sheetRow = []
            this.props.columns.map(column => {
                const getValue = (row) => get(row, column)
                sheetRow.push(getValue(row) || '')
            })
            sheetData.push(sheetRow)
        })

        return sheetData
    }

    download = () => {
        const wb = {
            SheetNames: ["Lista"],
            Sheets: {"Lista": sheet_from_array_of_arrays(this.createSheetData(this.props.columns, this.state.response.items, this.props.labels))},
        }

        const wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'})
        saveAs(new Blob([s2ab(wbout)], {type:"application/octet-stream"}), this.props.settings.filename || 'data.xlsx')
    }

    isLoading = () => {
        return this.state.response.items.length < this.state.response.fullcount || this.state.response.page === 0;
    }

    render() {
        if (this.state.opened) {
            return (
                <Portal>
                    <Modal
                        header="Exportálás"
                        state="on"
                        size="small"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default"},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.request && this.request.cancel();
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Letöltés',
                                props: {color: "primary", disabled: !this.state.generated},
                                onClick: async () => {
                                    if (this.state.generated) {
                                        this.download();
                                    }
                                }
                            }
                        ]}
                    >
                        <ProgressBar
                            min={0}
                            max={this.state.response.fullcount}
                            now={this.state.response.items.length}
                            style={{minWidth: this.state.response.items.length > 0 ? '140px' : 0}}
                            label={`${this.state.response.items.length} db / ${this.state.response.fullcount} db`}
                        />
                    </Modal>
                </Portal>
            );
        } else {
            return null;
        }
    }
}